import React, { useContext } from "react";

import { amplitudeClient } from "@/bootstrap";

interface MetricsContextValue {
  eventContext?: string;
}

// Partial<> is only here due to existing tests are relying on the clients to be undefined
// this should be removed in the future so that we don't need to null check when accessing api clients

export interface Props extends Partial<MetricsContextValue> {}

export const MetricsContext = React.createContext<
  Partial<Readonly<MetricsContextValue>>
>({});

export const MetricsProvider: React.FC<Props> = ({
  children,
  eventContext,
}) => {
  return (
    <MetricsContext.Provider
      value={{
        eventContext,
      }}
    >
      {children}
    </MetricsContext.Provider>
  );
};

export const useMetrics = () => {
  const value = useContext(MetricsContext);
  if (!value) {
    throw Error("MetricsContext is not set");
  }

  return {
    ...(value as MetricsContextValue),
    emit: (type: string, data?: object) => {
      if (typeof window !== "undefined" && window.PubSub) {
        window.PubSub.publish(`EVENT.${type}`, data);
      }
    },
    track: (type: string, data?: object) => {
      if (amplitudeClient) {
        amplitudeClient.logEvent(type, {
          event_context: value.eventContext,
          ...(data || {}),
        });
      }
      if (typeof window !== "undefined" && window.PubSub) {
        window.PubSub.publish(`TRACK.${type}`, data);
      }
    },
  };
};
